module.exports = __webpack_public_path__ + "img/orange-square-table-3.5f13e2ac.png";